// extracted by mini-css-extract-plugin
export default {"navButton":"NavButton_navButton__qQmZ-","icon":"NavButton_icon__ql40d"};